export default {
  apiUrl: 'https://tgear.eu',
}